export default "__VITE_ASSET__DPfHoHPo__"